<template>
  <div class="contact">
    <el-autocomplete
      v-model="mapLocation.address"
      :fetch-suggestions="querySearch"
      placeholder="请输入详细地址"
      style="width: 100%"
      :trigger-on-focus="false"
      @select="handleSelect"
    />
    <div style="margin: 5px">
      <baidu-map
        class="map"
        :center="mapCenter"
        :zoom="mapZoom"
        :scroll-wheel-zoom="true"
        @click="clickEvent"
        @zoomend="syncCenterAndZoom"
        @ready="handlerBMap"
      >
        <!-- 在右上角加入比例尺控件 -->
        <bm-scale anchor="BMAP_ANCHOR_TOP_RIGHT"></bm-scale>
        <!-- 在右上角加入缩放控件 -->
        <bm-navigation anchor="BMAP_ANCHOR_TOP_RIGHT"></bm-navigation>
        <!-- 在地图左上角加入地图类型控件 -->
        <!-- <bm-map-type :map-types="['BMAP_NORMAL_MAP', 'BMAP_HYBRID_MAP']"
                     anchor="BMAP_ANCHOR_TOP_LEFT"></bm-map-type> -->
        <!-- 在地图右下角加入缩略图控件 -->
        <bm-overview-map
          anchor="BMAP_ANCHOR_BOTTOM_RIGHT"
          :isOpen="true"
        ></bm-overview-map>
        <!-- 在地图右下角加入定位控件 -->
        <bm-geolocation
          anchor="BMAP_ANCHOR_BOTTOM_RIGHT"
          :showAddressBar="true"
          @locationSuccess="locationSuccess"
          :autoLocation="true"
        ></bm-geolocation>
        <!-- 在地图左上角加入城市切换控件 -->
        <bm-city-list anchor="BMAP_ANCHOR_TOP_LEFT"></bm-city-list>
        <!-- 在地图中心添加可拖动的跳跃点标记 -->
        <bm-marker
          :position="mapCenter"
          :dragging="true"
          animation="BMAP_ANIMATION_BOUNCE"
        >
          <bm-label
            content="你在此"
            :labelStyle="{ color: 'red', fontSize: '12px' }"
            :offset="{ width: -10, height: 20 }"
          />
        </bm-marker>
        <bm-context-menu>
          <bm-context-menu-item
            :callback="callbackItem"
            text="去北京1"
          ></bm-context-menu-item>
        </bm-context-menu>
      </baidu-map>
    </div>
  </div>
</template>
 
<script>
export default {
  data() {
    return {
      mapZoom: 16,
      mapCenter: { lng: 125.347485, lat: 43.883944 },
      mapLocation: {
        address: undefined,
        coordinate: undefined,
      },
    };
  },
  methods: {
    // 可以直接设置坐标位置
    syncCenterAndZoom(e) {
      // const { lng, lat } = e.target.getCenter()
      // this.mapCenter.lng = lng
      // this.mapCenter.lat = lat
      // this.mapZoom = e.target.getZoom()
    },
    callbackItem({ type, target, point, pixel }) {
      console.log(111);
    },
    clickEvent(e) {
      this.mapCenter = e.point;
      const geocoder = new this.BMap.Geocoder();
      geocoder.getLocation(e.point, (rs) => {
        this.mapLocation.address = rs.address;
        // 这里打印可以看到里面的详细地址信息，可以根据需求选择想要的
        console.log(rs.address);
        // 结构化的地址描述(object)
        console.log(rs.addressComponents);
        // 省
        console.log(rs.addressComponents.province);
        // 城市
        console.log(rs.addressComponents.city);
        // 区县
        console.log(rs.addressComponents.district);
        //  街道
        console.log(rs.addressComponents.street);
        //  门牌号
        console.log(rs.addressComponents.streetNumber);
        //  附近的POI点(array)
        console.log(rs.surroundingPois);
        //  商圈字段，代表此点所属的商圈(string)
        console.log(rs.business);
      });
    },
    handlerBMap({ BMap, map }) {
      this.BMap = BMap;
      this.map = map;
      if (this.mapLocation.coordinate && this.mapLocation.coordinate.lng) {
        this.mapCenter.lng = this.mapLocation.coordinate.lng;
        this.mapCenter.lat = this.mapLocation.coordinate.lat;
        this.mapZoom = 15;
        map.addOverlay(new this.BMap.Marker(this.mapLocation.coordinate));
      } else {
        this.mapCenter.lng = 113.271429;
        this.mapCenter.lat = 23.135336;
        this.mapZoom = 10;
      }
    },
    querySearch(queryString, cb) {
      var that = this;
      var myGeo = new this.BMap.Geocoder();
      myGeo.getPoint(
        queryString,
        function (point) {
          if (point) {
            that.mapLocation.coordinate = point;
            that.makerCenter(point);
          } else {
            that.mapLocation.coordinate = null;
          }
        },
        this.locationCity
      );
      var options = {
        onSearchComplete: function (results) {
          if (local.getStatus() === 0) {
            // 判断状态是否正确
            var s = [];
            for (var i = 0; i < results.getCurrentNumPois(); i++) {
              var x = results.getPoi(i);
              var item = { value: x.address + x.title, point: x.point };
              s.push(item);
              cb(s);
            }
          } else {
            cb();
          }
        },
      };
      var local = new this.BMap.LocalSearch(this.map, options);
      local.search(queryString);
    },
    handleSelect(item) {
      var { point } = item;
      this.mapLocation.coordinate = point;
      this.makerCenter(point);
    },
    makerCenter(point) {
      if (this.map) {
        this.map.clearOverlays();
        this.map.addOverlay(new this.BMap.Marker(point));
        this.mapCenter.lng = point.lng;
        this.mapCenter.lat = point.lat;
        this.mapZoom = 15;
      }
    },
    // 定位成功之后的回调
    locationSuccess(point, AddressComponent, marker) {
      // console.log(point.point)
      this.mapCenter = point.point;
    },
  },
};
</script>
 
<style>
.map {
  width: 100vw;
  height: 100vh;
}
</style>